import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Bitcoin() {
  return (
    <PredictionPage
      title="Bitcoin"
      content="This is the Bitcoin AI Trading Predictions page."
      canonical="/cryptocurrencies/bitcoin-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="BITCOIN"
    />
  );
}

export default Bitcoin;
